const INITIAL_STATE = {
  loading: false,
  obj: {},
  additionalData: {
    banks: [],
    company_types: [],
    business_areas: [],
  },
  additionalDataLoading: false,
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'USER_STEPS_FETCHED':
      return { ...state, obj: action.payload, loading: false };
    case 'USER_STEPS_LOAD':
      return { ...state, loading: action.payload };
    case 'ADDITIONAL_DATA_FETCHED':
      return {
        ...state,
        additionalData: action.payload,
        additionalDataLoading: false,
      };
    case 'ADDITIONAL_DATA_LOAD':
      return { ...state, additionalDataLoading: action.payload };
    default:
      return state;
  }
};
